<template>
  <div @click="(e) => { $emit('click', e); changeIcon() }">
    <div
      class="d-flex align-items-center cursor-pointer"
      style="width: max-content"
    >
      <span class="mr-gd-half -mt-3"><i class="far fa-star fs-14"/></span>
      <div
        class="d-flex align-items-center"
        style="font-family: Tahoma; font-size: 12px"
      >
        Change Icon
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {}
  },
  methods: {
    changeIcon() {
      this.$emit('open');
      this.$store.dispatch("designIframe/modals/setModal", {
        modal_id: "modal-filemanager",
        payload: {
          componentConfig: {
            type: "texteditor-icon",
            changeIcon: true,
          },
          selectDirectoryType: 'icon',
          isShowDocument: false,
          isShowImage: false,
          isShowUnsplash: false,
          isShowFlaticon: false,
          isShowIcon: true,
        },
        callback:{
          onSubmit: (value) => {
            this.$emit('submit', value);
          },
          onClose: () => {
            this.$emit('close');
          },
        },
      });
    },
  },
}
</script>
